(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/team-show-link.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/team-show-link.js');
'use strict';

const Icon = svs.ui.ReactIcon;
const {
  ReactButton: Button,
  ReactIconButton: IconButton
} = svs.ui;
const {
  buildInviteLinkUrl
} = svs.arena.pages.teams.helpers;
const {
  showCopyInviteLinkFailToaster,
  showCopyInviteLinkSuccessToaster,
  showShareFailedToaster
} = svs.arena.pages.teams.dialogs;
const TeamShowLink = _ref => {
  let {
    isExpanded = true,
    teamId,
    isCreate = false
  } = _ref;
  const inviteIds = ReactRedux.useSelector(state => {
    var _state$teams;
    return (_state$teams = state.teams) === null || _state$teams === void 0 ? void 0 : _state$teams.inviteIds;
  }) || [];
  const [isLinkOld, setIsLinkOld] = React.useState(false);
  const [copyIcon, setCopyIcon] = React.useState('copy');
  const [disableShareButton, setDisableShareButton] = React.useState(false);
  const linkId = inviteIds.find(item => item.teamId === teamId);
  React.useEffect(() => {
    svs.arena.logger.debug('TeamShowLink, useEffect running');
    if (isExpanded && linkId !== null && linkId !== void 0 && linkId.validTo) {
      const isTooOld = dateFns.compareAsc(Date.now(), dateFns.addDays(dateFns.parseISO(linkId.validTo), -5));
      setIsLinkOld(isTooOld === 1);
    }
  }, [isExpanded, linkId.validTo]);
  const copyLinkToClipBoard = async () => {
    svs.arena.logger.debug('TeamShowLink, copyLinkToClipBoard');
    svs.ui.loader.show();
    try {
      await navigator.clipboard.writeText(buildInviteLinkUrl(linkId.linkId));
      const track = {
        category: 'spela-tillsammans',
        action: isCreate ? 'new_team' : 'invite_members',
        opt_label: 'copy_link'
      };
      svs.components.analytics.trackEvent(track);
    } catch (error) {
      showCopyInviteLinkFailToaster();
      svs.ui.loader.hide();
      return;
    }
    svs.ui.loader.hide();
    setCopyIcon('checkmark');
    setDisableShareButton(true);
    setTimeout(() => {
      setCopyIcon('copy');
      setDisableShareButton(false);
    }, 3000);
    showCopyInviteLinkSuccessToaster();
  };
  const shareLink = async () => {
    if (navigator.canShare) {
      try {
        await navigator.share({
          title: 'Svenska Spel Tur - Spela tillsammans',
          text: 'svenskaspel.se/spela-tillsammans',
          url: buildInviteLinkUrl(linkId.linkId)
        });
        const track = {
          category: 'spela-tillsammans',
          action: isCreate ? 'new_team' : 'invite_members',
          opt_label: 'copy_link'
        };
        svs.components.analytics.trackEvent(track);
      } catch (error) {
        if (error.code !== 11) {
          showShareFailedToaster();
        }
      }
    } else {
      copyLinkToClipBoard();
    }
  };
  const daysLeft = () => dateFns.differenceInCalendarDays(dateFns.parseISO(linkId.validTo), Date.now());
  return React.createElement("div", null, linkId && React.createElement("div", {
    className: "align-center f-body"
  }, React.createElement("div", {
    className: "bg-tur-100 padding-1 u-border-radius-4 margin-v u-flex u-flex-justify-content-center w-100"
  }, React.createElement("div", null, buildInviteLinkUrl(linkId.linkId)), React.createElement(IconButton, {
    "aria-label": "Kopiera l\xE4nken",
    disabled: disableShareButton,
    onClick: copyLinkToClipBoard,
    type: "button"
  }, React.createElement(Icon, {
    className: "padding-1",
    icon: copyIcon
  }))), isLinkOld && React.createElement("div", {
    className: "f-italic align-left"
  }, "L\xE4nken \xE4r giltig i ".concat(daysLeft(), " ").concat(daysLeft() === 1 ? 'dag' : 'dagar', " till.")), React.createElement(Button, {
    block: true,
    className: "margin-top-1 margin-bottom-1",
    disabled: disableShareButton,
    inverted: true,
    onClick: shareLink,
    size: 300
  }, "Dela l\xE4nk")));
};
svs.arena.pages.teams.components.TeamShowLink = TeamShowLink;

 })(window);